// Supplementary EN/AR copy merged into translations at runtime (launch-hardening pass).
const extra = {
  en: {
    common: { ai_disclaimer: "AI-generated responses may contain errors. Verify important details before acting.", demo_strong: "DEMO DATA — not live listings or transactions", arabic_beta: "Arabic (beta)" },
    home: {
      discover: {
        eyebrow: "Discover Dubai",
        h: "Real estate, business and lifestyle — in one place.",
        p: "BuyDubai.ai now helps you discover Dubai's restaurants, shops and local businesses alongside property and broker tools.",
        open: "Open",
        items: {
          restaurants: { h: "Restaurants & Cafes", p: "Dining by cuisine and neighbourhood" },
          shopping: { h: "Markets & Shopping", p: "Supermarkets, malls and specialty stores" },
          directory: { h: "Businesses", p: "Local companies and services" },
          property: { h: "Real Estate", p: "Property discovery and pricing" },
          broker: { h: "Broker CMA", p: "Comparable sales reports for brokers" },
        },
      },
      live_line: "Live: Property · More verticals coming soon",
      prompts_soon: [
        { text: "I'm moving to Dubai with my family.", tag: "Relocation — coming soon" },
        { text: "Get me three AC repair quotes tonight.", tag: "Services — coming soon" },
        { text: "I want to start a company in Dubai.", tag: "Business — coming soon" },
      ],
      broker: {
        eyebrow: "For Dubai brokers",
        h: "Price any property in seconds.",
        p: "Run a comparative market analysis from recent transaction data, see exactly which comparables were used and why, and export a clean report for your seller pitch.",
        bullets: ["Every figure traceable to source transactions", "Inclusion and exclusion reasons shown", "Print-ready seller report", "Free during pilot"],
        cta: "Try the Broker CMA",
      },
    },
    ask: {
      disclaimer: "Results are DEMO data — not live listings or transactions. AI answers may contain errors; verify before acting.",
      waitlist_h: "Be first when new verticals launch",
      waitlist_p: "Local Services, Relocation, Business Setup and more are coming soon. Get notified.",
      waitlist_ph: "Your email",
      waitlist_btn: "Join waitlist",
      waitlist_ok: "You're on the list — we'll be in touch at launch.",
    },
    broker: {
      pilot_tag: "Pilot — free, no charge",
      land_h: "Price any property in seconds.",
      land_p: "The Broker CMA turns recent transaction data into a defensible comparative market analysis. See which comparables were used and why, then export a clean, print-ready report for your seller pitch.",
      how_h: "How it works",
      how: [
        { h: "Enter the subject", p: "Area, building, beds, size and asking price." },
        { h: "We compute the CMA", p: "Median, P25–P75 and deviation from real comparable transactions — every figure traceable." },
        { h: "Export your report", p: "A clean, print-ready analysis for your seller conversation." },
      ],
      sample_h: "Sample report",
      sample_note: "Illustrative sample — DEMO data, not official or live records.",
      pilot_h: "Join the free broker pilot",
      pilot_p: "Tell us about your desk and we'll send pilot access within 48 hours.",
      pilot_fields: { name: "Full name", agency: "Agency", brn: "RERA / BRN number", email: "Email", phone: "Phone / WhatsApp", areas: "Areas covered", feed: "Current CRM or listing feed format", listings: "Properties listed per month" },
      pilot_submit: "Request pilot access",
      pilot_ok_h: "Thanks — you're in the pilot queue",
      pilot_ok_p: "We'll send your pilot access within 48 hours.",
      no_official: "The Broker CMA uses sample transaction data during the pilot. It is not official, live, or government-sourced.",
      dash_link: "My CMA reports",
      dash_title: "Broker dashboard",
      dash_sub: "Your saved CMA reports and pilot status in one place.",
      dash_pilot_h: "Pilot status",
      dash_pilot_applied: "You're in the pilot queue",
      dash_pilot_applied_sub: "We'll send your pilot access within 48 hours.",
      dash_pilot_none: "You haven't applied to the free broker pilot yet.",
      dash_pilot_cta: "Apply to the pilot",
      dash_reports_h: "Saved CMA reports",
      dash_empty: "No saved reports yet. Run a CMA and it will appear here.",
      dash_run_cta: "Run a CMA",
      dash_open: "Open workbench",
      col_subject: "Subject", col_confidence: "Confidence", col_median: "Median", col_deviation: "Deviation", col_range: "Suggested range", col_date: "Date",
      reopen: "Reopen",
      notes_h: "Report notes",
      notes_ph: "Add private notes for your seller pitch…",
      notes_save: "Save notes",
      notes_saved: "Notes saved",
      reopened: "Report reopened",
      pilot_approved: "Approved — pilot access granted",
      pilot_pending: "In the pilot queue",
    },
    admin: {
      eyebrow: "Admin", title: "Broker pilot applications",
      sub: "Review incoming broker pilot requests and approve access.",
      empty: "No pilot applications yet.",
      review_link: "Review broker pilots",
      approve: "Approve", reject: "Reject",
      cols: ["Applicant", "Agency / BRN", "Contact", "Volume", "Status", "Action"],
      st_pending: "Pending", st_approved: "Approved", st_rejected: "Rejected",
      approved_emailed: "Approved — broker notified by email",
      approved_logged: "Approved — email pending (no email provider connected yet)",
      approved_email_failed: "Approved — but email failed to send. Verify your sending domain in Resend.",
      rejected_done: "Application rejected",
      filter_status: "Status", filter_all: "All", filter_search_ph: "Search agency or area…",
      no_match: "No applications match your filters.",
      wl_h: "Waitlist launches", wl_sub: "Announce a vertical to everyone waiting for it.",
      wl_cap: "Vertical", wl_total: "On waitlist", wl_pending: "Not yet notified", wl_action: "Launch & email",
      wl_empty: "No one on the waitlist yet.",
      wl_launched: "Launched — {sent} email(s) sent",
      wl_logs: "Launch recorded, but no emails sent (connect/verify Resend to notify).",
      wl_locked: "Coming soon — not announceable",
      wl_confirm_title: "Confirm waitlist launch",
      wl_confirm_body: "This will email {count} recipient(s) that {name} is now live. This cannot be undone.",
      wl_confirm_type: "Type the vertical name to confirm:",
      wl_cancel: "Cancel", wl_confirm_btn: "Launch now",
      dec_h: "Pilot decline notes",
      dec_sub: "Rejected applicants who haven't been sent a decline note yet. Review the list, then send — nothing is emailed automatically.",
      dec_empty: "No pending decline notes.",
      dec_selected: "selected",
      dec_send: "Send decline emails",
      dec_sent: "Sent {sent} decline email(s)",
      dec_logs: "Recorded, but no emails sent (M365 sender not configured in this environment).",
      dec_confirm_title: "Send decline notes",
      dec_confirm_body: "This will email {count} declined applicant(s) from partners@buydubai.ai. Send only to people who applied.",
      dec_confirm_btn: "Send now",
    },
    nav: { brokers: "For Brokers", discover: "Discover", restaurants: "Restaurants & Cafes", shopping: "Markets & Shopping", directory: "Business Directory", discover_h: "Discover Dubai" },
    directory: {
      eyebrow: "Discover Dubai",
      sections: {
        restaurants: { title: "Restaurants & Cafes", sub: "Restaurants, cafes and bakeries across Dubai. Search by name or cuisine and filter by neighbourhood." },
        shopping: { title: "Markets & Shopping", sub: "Supermarkets, grocery and specialty food stores, malls, electronics and retail shops across Dubai." },
        directory: { title: "Dubai Business Directory", sub: "Local companies and services — professional services, car rental, pharmacies, banks and more." },
      },
      data_from: "Listings sourced from",
      search: "Search", search_ph: "Business name, cuisine or brand",
      category: "Category", neighborhood: "Neighbourhood", cuisine: "Cuisine",
      all_categories: "All categories", all_neighborhoods: "All neighbourhoods", all_cuisines: "All cuisines",
      clear: "Clear", result: "place", results: "places",
      prev: "Previous", next: "Next", retry: "Try again", loading: "Loading…",
      error_h: "We couldn't load listings", error_p: "Something went wrong reaching the directory. Please try again.",
      empty_h: "No places match", empty_p: "Try a different name, or clear some filters.",
      notfound_h: "Listing not found", notfound_p: "This business isn't in the directory, or the link is out of date.",
      page_out_h: "That page doesn't exist",
      soon_h: "Listings are on their way", soon_p: "We're adding verified Dubai places to this section. Please check back soon.", page_out_p: "There are fewer results than that page number.", first_page: "Go to first page",
      location_unavailable: "Area not verified.",
      nb_boundary: "OpenStreetMap community boundary", nb_manual: "verified by BuyDubai.ai",
      address: "Address", phone: "Phone", email: "Email", website: "Website", hours: "Opening hours", brand: "Brand",
      not_available: "Not available",
      approx_area: "approximate, nearest mapped area", as_listed: "as listed on OpenStreetMap",
      unverified: "Unverified listing — imported from OpenStreetMap and not yet confirmed by the business or BuyDubai.ai. Check details before visiting.",
      verified: "Verified listing.",
      source: "Source: OpenStreetMap",
      first_imported: "First imported", last_seen: "Last refreshed",
      view_osm_record: "View or improve this record on OpenStreetMap", view_map: "View on map",
    },
    legal: {
      privacy_body: [
        "BuyDubai.ai (\u201cwe\u201d), operated by Buy-Tech.ai, respects your privacy. This policy explains what we collect, why, how long we keep it, and how you can control it.",
        "What we collect: (1) Account data you provide — name, email, password (stored only as a secure hash). (2) Preferences you choose to save (budget, areas, family needs, etc.) on the \u201cWhat BuyDubai knows about me\u201d page. (3) Content of conversations you have with the AI, used only to fulfil your request. (4) Form submissions (partner and broker-pilot applications, waitlist). (5) Basic, privacy-friendly analytics events (page views, feature usage) with IP handling minimised.",
        "Why we collect it: to provide the service, remember your preferences, respond to applications, and improve the product. We do not sell your personal data and we do not use it for third-party advertising.",
        "Retention: account and preference data are kept until you delete them or close your account. Conversation and analytics data are retained only as long as needed for the purposes above.",
        "Your rights & deletion: you can view, edit and delete your saved preferences at any time from the \u201cWhat BuyDubai knows about me\u201d page, and you can request full deletion of your account and data by emailing privacy@buydubai.ai.",
        "UAE PDPL: we aim to align with the UAE Personal Data Protection Law (Federal Decree-Law No. 45 of 2021). For any data-protection request or question, contact our data controller at privacy@buydubai.ai.",
      ],
      terms_body: [
        "These Terms govern your use of BuyDubai.ai, operated by Buy-Tech.ai. By using the service you agree to them.",
        "What the service is: BuyDubai.ai is an AI platform that helps you discover, compare and act on goals across Dubai. Property is the only capability live today; all other verticals are clearly labelled \u201ccoming soon.\u201d",
        "DEMO data: provider listings, prices, comparable transactions, quotes and businesses shown during this launch and pilot phase are sample/DEMO data. They are not official, live, or government-sourced, and must be independently verified before you act on them.",
        "AI limitations: AI-generated responses may contain errors or omissions. They are not professional, legal, financial or real-estate advice. Verify important information before making decisions.",
        "No unsupported claims: we make no representations of government partnerships, live DLD inventory, verified provider networks, user or transaction counts, or guaranteed savings or returns.",
        "Contact: partners@buydubai.ai. Powered by Buy-Tech.ai.",
      ],
    },
  },
  ar: {
    common: { ai_disclaimer: "قد تحتوي ردود الذكاء الاصطناعي على أخطاء. تحقق من التفاصيل المهمة قبل اتخاذ أي إجراء.", demo_strong: "بيانات تجريبية — ليست قوائم أو معاملات حية", arabic_beta: "العربية (تجريبي)" },
    home: {
      live_line: "مباشر: العقارات · مجالات أخرى قريباً",
      prompts_soon: [
        { text: "أنا أنتقل إلى دبي مع عائلتي.", tag: "الانتقال — قريباً" },
        { text: "احصل لي على ثلاثة عروض لإصلاح المكيّف الليلة.", tag: "الخدمات — قريباً" },
        { text: "أريد تأسيس شركة في دبي.", tag: "الأعمال — قريباً" },
      ],
      broker: {
        eyebrow: "لوسطاء دبي",
        h: "سعّر أي عقار في ثوانٍ.",
        p: "أنشئ تحليل سوق مقارن من بيانات المعاملات الحديثة، وشاهد بالضبط أي المقارنات استُخدمت ولماذا، وصدّر تقريراً أنيقاً لعرضك على البائع.",
        bullets: ["كل رقم قابل للتتبع إلى معاملات المصدر", "عرض أسباب التضمين والاستبعاد", "تقرير جاهز للطباعة", "مجاني خلال الفترة التجريبية"],
        cta: "جرّب تحليل السوق للوسطاء",
      },
    },
    ask: {
      disclaimer: "النتائج بيانات تجريبية — ليست قوائم أو معاملات حية. قد تحتوي إجابات الذكاء الاصطناعي على أخطاء؛ تحقق قبل التصرّف.",
      waitlist_h: "كن أول من يعلم عند إطلاق مجالات جديدة",
      waitlist_p: "الخدمات المحلية والانتقال وتأسيس الأعمال والمزيد قريباً. احصل على إشعار.",
      waitlist_ph: "بريدك الإلكتروني",
      waitlist_btn: "انضم لقائمة الانتظار",
      waitlist_ok: "تمت إضافتك — سنتواصل معك عند الإطلاق.",
    },
    broker: {
      pilot_tag: "تجريبي — مجاني بدون رسوم",
      land_h: "سعّر أي عقار في ثوانٍ.",
      land_p: "يحوّل تحليل السوق للوسطاء بيانات المعاملات الحديثة إلى تحليل سوق مقارن يمكن الدفاع عنه. شاهد أي المقارنات استُخدمت ولماذا، ثم صدّر تقريراً أنيقاً جاهزاً للطباعة.",
      how_h: "كيف يعمل",
      how: [
        { h: "أدخل بيانات العقار", p: "المنطقة والمبنى وعدد الغرف والمساحة والسعر المطلوب." },
        { h: "نحسب التحليل", p: "الوسيط والمئين 25–75 والانحراف من معاملات مماثلة حقيقية — كل رقم قابل للتتبع." },
        { h: "صدّر تقريرك", p: "تحليل أنيق جاهز للطباعة لمحادثتك مع البائع." },
      ],
      sample_h: "نموذج تقرير",
      sample_note: "نموذج توضيحي — بيانات تجريبية، وليست سجلات رسمية أو حية.",
      pilot_h: "انضم للفترة التجريبية المجانية للوسطاء",
      pilot_p: "أخبرنا عن مكتبك وسنرسل لك صلاحية الوصول التجريبية خلال 48 ساعة.",
      pilot_fields: { name: "الاسم الكامل", agency: "الوكالة", brn: "رقم ريرا / BRN", email: "البريد الإلكتروني", phone: "الهاتف / واتساب", areas: "المناطق المغطاة", feed: "نظام CRM أو صيغة تغذية القوائم الحالية", listings: "عدد العقارات المدرجة شهرياً" },
      pilot_submit: "اطلب صلاحية الوصول التجريبية",
      pilot_ok_h: "شكراً — أنت في قائمة الانتظار التجريبية",
      pilot_ok_p: "سنرسل لك صلاحية الوصول التجريبية خلال 48 ساعة.",
      no_official: "يستخدم تحليل السوق للوسطاء بيانات معاملات تجريبية خلال الفترة التجريبية. وهي ليست رسمية أو حية أو من مصادر حكومية.",
      dash_link: "تقارير التحليل الخاصة بي",
      dash_title: "لوحة الوسيط",
      dash_sub: "تقارير تحليل السوق المحفوظة وحالة الفترة التجريبية في مكان واحد.",
      dash_pilot_h: "حالة الفترة التجريبية",
      dash_pilot_applied: "أنت في قائمة الانتظار التجريبية",
      dash_pilot_applied_sub: "سنرسل لك صلاحية الوصول التجريبية خلال 48 ساعة.",
      dash_pilot_none: "لم تتقدّم بعد للفترة التجريبية المجانية للوسطاء.",
      dash_pilot_cta: "تقدّم للفترة التجريبية",
      dash_reports_h: "تقارير تحليل السوق المحفوظة",
      dash_empty: "لا توجد تقارير محفوظة بعد. شغّل تحليلاً وسيظهر هنا.",
      dash_run_cta: "شغّل تحليلاً",
      dash_open: "افتح الورشة",
      col_subject: "العقار", col_confidence: "الثقة", col_median: "الوسيط", col_deviation: "الانحراف", col_range: "النطاق المقترح", col_date: "التاريخ",
      reopen: "إعادة الفتح",
      notes_h: "ملاحظات التقرير",
      notes_ph: "أضف ملاحظات خاصة لعرضك على البائع…",
      notes_save: "حفظ الملاحظات",
      notes_saved: "تم حفظ الملاحظات",
      reopened: "تمت إعادة فتح التقرير",
      pilot_approved: "مُعتمد — تم منح الوصول التجريبي",
      pilot_pending: "في قائمة الانتظار التجريبية",
    },
    admin: {
      eyebrow: "المشرف", title: "طلبات الفترة التجريبية للوسطاء",
      sub: "راجع طلبات الوسطاء الواردة واعتمد الوصول.",
      empty: "لا توجد طلبات بعد.",
      review_link: "مراجعة طلبات الوسطاء",
      approve: "اعتماد", reject: "رفض",
      cols: ["المتقدّم", "الوكالة / BRN", "التواصل", "الحجم", "الحالة", "إجراء"],
      st_pending: "قيد الانتظار", st_approved: "مُعتمد", st_rejected: "مرفوض",
      approved_emailed: "تم الاعتماد — تم إخطار الوسيط بالبريد",
      approved_logged: "تم الاعتماد — البريد قيد الانتظار (لم يتم ربط مزوّد بريد بعد)",
      approved_email_failed: "تم الاعتماد — لكن فشل إرسال البريد. تحقّق من نطاق الإرسال في Resend.",
      rejected_done: "تم رفض الطلب",
      filter_status: "الحالة", filter_all: "الكل", filter_search_ph: "ابحث بالوكالة أو المنطقة…",
      no_match: "لا توجد طلبات تطابق عوامل التصفية.",
      wl_h: "إطلاق قوائم الانتظار", wl_sub: "أعلن عن مجال لكل من ينتظره.",
      wl_cap: "المجال", wl_total: "في قائمة الانتظار", wl_pending: "لم يُخطَر بعد", wl_action: "إطلاق وإرسال",
      wl_empty: "لا أحد في قائمة الانتظار بعد.",
      wl_launched: "تم الإطلاق — تم إرسال {sent} بريد",
      wl_logs: "تم تسجيل الإطلاق، لكن لم تُرسل رسائل (اربط/وثّق Resend للإخطار).",
      wl_locked: "قريباً — غير قابل للإعلان",
      wl_confirm_title: "تأكيد إطلاق قائمة الانتظار",
      wl_confirm_body: "سيتم إرسال بريد إلى {count} مستلم بأن {name} أصبح متاحاً الآن. لا يمكن التراجع.",
      wl_confirm_type: "اكتب اسم المجال للتأكيد:",
      wl_cancel: "إلغاء", wl_confirm_btn: "إطلاق الآن",
      dec_h: "رسائل رفض الطيار",
      dec_sub: "المتقدّمون المرفوضون الذين لم تُرسل لهم رسالة رفض بعد. راجع القائمة ثم أرسل — لا يُرسل أي بريد تلقائياً.",
      dec_empty: "لا توجد رسائل رفض معلّقة.",
      dec_selected: "محدد",
      dec_send: "إرسال رسائل الرفض",
      dec_sent: "تم إرسال {sent} رسالة رفض",
      dec_logs: "تم التسجيل، لكن لم يُرسل بريد (لم يُهيّأ مرسل M365 في هذه البيئة).",
      dec_confirm_title: "إرسال رسائل الرفض",
      dec_confirm_body: "سيتم إرسال بريد إلى {count} متقدّم مرفوض من partners@buydubai.ai. أرسل فقط لمن تقدّم بطلب.",
      dec_confirm_btn: "أرسل الآن",
    },
    nav: { brokers: "للوسطاء" },
    legal: {
      privacy_body: [
        "تحترم BuyDubai.ai (\u201cنحن\u201d)، والمُشغّلة بواسطة Buy-Tech.ai، خصوصيتك. توضّح هذه السياسة ما نجمعه ولماذا وكم نحتفظ به وكيف يمكنك التحكم فيه.",
        "ما نجمعه: (1) بيانات الحساب التي تقدّمها — الاسم والبريد وكلمة المرور (تُخزَّن فقط كتجزئة آمنة). (2) التفضيلات التي تختار حفظها. (3) محتوى محادثاتك مع الذكاء الاصطناعي، ويُستخدم فقط لتلبية طلبك. (4) نماذج الطلبات (الشركاء والوسطاء وقائمة الانتظار). (5) تحليلات بسيطة تحترم الخصوصية مع تقليل التعامل مع عنوان IP.",
        "لماذا نجمعها: لتقديم الخدمة وتذكّر تفضيلاتك والرد على الطلبات وتحسين المنتج. لا نبيع بياناتك الشخصية ولا نستخدمها لإعلانات طرف ثالث.",
        "الاحتفاظ: تُحفظ بيانات الحساب والتفضيلات حتى تحذفها أو تغلق حسابك. تُحفظ بيانات المحادثات والتحليلات فقط للمدة اللازمة للأغراض المذكورة.",
        "حقوقك والحذف: يمكنك عرض وتعديل وحذف تفضيلاتك في أي وقت من صفحة \u201cما يعرفه BuyDubai عني\u201d، وطلب حذف حسابك وبياناتك بالكامل عبر privacy@buydubai.ai.",
        "قانون حماية البيانات الإماراتي (PDPL): نسعى للتوافق مع المرسوم بقانون اتحادي رقم 45 لسنة 2021. لأي طلب يخص حماية البيانات تواصل مع privacy@buydubai.ai.",
      ],
      terms_body: [
        "تحكم هذه الشروط استخدامك لـ BuyDubai.ai، المُشغّلة بواسطة Buy-Tech.ai. باستخدامك للخدمة فإنك توافق عليها.",
        "ما هي الخدمة: BuyDubai.ai منصة ذكاء اصطناعي تساعدك على الاكتشاف والمقارنة واتخاذ الإجراء في دبي. العقارات هي القدرة الوحيدة المتاحة اليوم؛ وبقية المجالات مُعلّمة بوضوح \u201cقريباً\u201d.",
        "البيانات التجريبية: القوائم والأسعار والمعاملات المماثلة والعروض والأعمال المعروضة خلال مرحلة الإطلاق والتجربة هي بيانات تجريبية. وهي ليست رسمية أو حية أو من مصادر حكومية، ويجب التحقق منها بشكل مستقل قبل التصرّف.",
        "حدود الذكاء الاصطناعي: قد تحتوي الردود على أخطاء أو نواقص. وهي ليست استشارة مهنية أو قانونية أو مالية أو عقارية. تحقق من المعلومات المهمة قبل اتخاذ القرارات.",
        "لا ادعاءات غير مدعومة: لا نقدّم أي إقرارات بشراكات حكومية أو مخزون DLD حي أو شبكات مزوّدين موثّقة أو أعداد مستخدمين أو معاملات أو ضمانات بالتوفير أو العوائد.",
        "للتواصل: partners@buydubai.ai. مُشغّل بواسطة Buy-Tech.ai.",
      ],
    },
  },
};

export default extra;
